<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">search</i>
                        </div>
                        <h4 class="card-title ">Filtros</h4>
                    </div>
                    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" novalidate="novalidate" autocomplete="off">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.type_profile_id != null}">
                                        <label for="type_profiles" class="bmd-label-floating">Tipos de Perfil</label>
                                        <multi-select
                                            v-model="form.type_profile_id"
                                            placeholder="Selecione os Tipos de Perfis"
                                            label="name"
                                            track-by="name"
                                            value="id"
                                            :options="type_profiles"
                                            :multiple="true"
                                            :clear-on-select="false"
                                            :preserve-search="true">
                                        </multi-select>
                                        <label v-if="validation.type_profile_id != null" id="type_profile_id-error" class="error" for="type_profile_id">{{ validation.type_profile_id }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="administrator_id" class="bmd-label-floating">Administradora</label>
                                        <model-list-select
                                            class="form-control"
                                            :list="administrators"
                                            placeholder="Todas"
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.administrator_id">
                                        </model-list-select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled">
                                        <label for="team_id" class="bmd-label-floating">Equipe</label>
                                        <model-list-select
                                            class="form-control"
                                            :list="teams"
                                            placeholder="Todas"
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.team_id">
                                        </model-list-select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.date_at != null}">
                                        <label for="interval" class="bmd-label-floating">Intervalo</label>
                                        <date-picker
                                            range
                                            v-model="form.date_at"
                                            lang="pt-br"
                                            format="DD/MM/YYYY"
                                            placeholder="Escolha uma data"
                                            >
                                        </date-picker>
                                        <label v-if="validation.date_at != null" id="date_at-error" class="error" for="date_at">{{ validation.date_at }}</label>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.date_by != null}">
                                        <label for="type_filter_date" class="bmd-label-floating">Filtar data por</label>
                                        <model-list-select
                                            class="form-control"
                                            :list="dates"
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.date_by">
                                        </model-list-select>
                                        <label v-if="validation.date_by != null" id="date_by-error" class="error" for="date_by">{{ validation.date_by }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                            <button type="submit" class="btn btn-fill btn-rose">Gerar</button>
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import TypeProfiles from '@/services/modules/typeprofiles.service';
    import Utils from '@/services/utils.service';

    export default {
        computed: {
            administrators: {
                get() {
                    return this.$store.state.administrators.itens;
                }
            },
            dates: {
                get() {
                    var dates = [
                        {id: 'sale_at', name: 'Data de Venda'},
                        {id: 'deployment_at', name: 'Data Alocação'},
                        {id: 'pay_at', name: 'Data de Pagamento'},
                        {id: 'pay_at-sale_at', name: 'Data de Pagamento (volume por data da venda)'},
                        {id: 'due_at', name: 'Data de Vencimento (apenas parcelas pagas)'},
                        {id: 'due_at-all', name: 'Data de Vencimento (parcelas pagas e não pagas)'},
                    ];

                    return dates;
                }
            },
            teams: {
                get() {
                    return this.$store.state.teams.itens;
                }
            }
        },
        data() {
            return {
                form: {
                    administrator_id: null,
                    date_at: [Vue.moment().subtract(30, "days"), Vue.moment()],
                    date_by: 'sale_at',
                    type_profile_id: [],
                    team_id: null
                },
                modalShow: false,
                type_profiles: [],
                validation: {
                    date_at: null,
                    date_by: null,
                    type_profile_id: null
                }
            };
        },
        methods: {
            goBack() {
                var self = this;
                self.modalShow = false;
            },
            onPrint() {
                Utils.printWithoutScreen("printReport");
            },
            onReset() {
                alert("Reset");
            },
            onSubmit() {
                var self = this;
                var form = self.form;
                var valid = true;
                var validation = self.validation;

                validation.date_at = null;
                validation.date_by = null;
                validation.type_profile_id = null;

                if (form.date_at[0] === null || form.date_at[1] === null) {
                    validation.date_at = "Favor informar o intervalo desejado!";
                    valid = false;
                }

                if (form.date_by === "") {
                    validation.date_by = "Favor selecionar a data desejada!";
                    valid = false;
                }

                if (form.type_profile_id.length === 0) {
                    validation.type_profile_id = "Favor selecionar ao menos um perfil!";
                    valid = false;
                }

                if (valid) {
                    var serialize = JSON.stringify(form);

                    window.open("print-commission-by-profiles?form=" + serialize, '_blank');
                }
            },
            async getDataAdministrators() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('administrators/all');

                response.then(function () {
                    self.getDataTeams();
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.getDataTeams();
                    self.$root.$emit("onLoading");
                });
            },
            async getDataProfiles() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = TypeProfiles.all();

                response.then(function (_profiles) {
                    self.type_profiles = _profiles.filter(profile => profile.id !== 1);
                    self.getDataAdministrators();
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    getDataAdministrators();
                    self.$root.$emit("onLoading");
                });
            },
            async getDataTeams() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('teams/all');

                response.then(function () {
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
        },
        mounted() {
            var self = this;

            self.getDataProfiles();

            setTimeout(() => {
                self.administrators.unshift(
                    {
                        id : '',
                        name : 'Todas'
                    }
                );
            }, 1000);

            self.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                self.goBack();
            });
        }
    }
</script>